import ChatMessage from './ChatMessage.component';

export default ChatMessage;